import { Component, ElementRef, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { isPlatformWorkerApp, Location } from '@angular/common';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { FieldItem } from 'src/app/models/common/field-item';
declare const loadScrollbar: any;
@Component({
  selector: 'sym-agent-add-note',
  templateUrl: './agent-add-note.component.html',
  styleUrls: ['./agent-add-note.component.scss'],
})
export class AgentAddNoteComponent extends BaseComponent<AgentService> implements OnInit {
  @ViewChild('notes') notesField: ElementRef;
  noteResponseData;
  currentResponseData;
  guid;
  isNotesAvailable: boolean = true;
  isShowSaveBtn: boolean = false;
  isEdit: boolean = false;
  editNoteValue;
  editResponseData;
  username: string;
  noteId;
  notesVersion;
  notesLength;

  constructor(
    service: AgentService,
    public route: ActivatedRoute,
    public router: Router,
    location: Location,
    public settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service);
  }

  ngOnInit() {
    this.guid = this.service.responseIO.data.Entity.guid;
    this.noteResponseData = [];
    this.getNoteHistory(this.guid);
    super.ngOnInit();
    $('.checkMakerNotes').hide();
    this.username = this.settingService.getSessionStorageValue('USER').replace(/"/g, '');
    this.username = this.username.toUpperCase();
  }

  getNoteHistory(guid: any) {
    this.noteResponseData = [];
    this.service.getNoteHistory(this.guid).subscribe((data) => {
      this.noteResponseData = data;
      this.notesLength = this.noteResponseData.data.notesHistoryList.length;
      // console.log("L"+this.noteResponseData.data.notesHistoryList.length)
      this.noteResponseData.data.notesHistoryList.slice(1).forEach(function (elemNotes) {
        setTimeout(() => {
          loadScrollbar($('.scrollDiv'));
          $('#' + elemNotes.guid + '_notesContent').attr('readonly', 'readonly');
        }, 15);
      });

      if (this.noteResponseData.data.notesHistoryList.length > 0) {
        this.isNotesAvailable = true;
        this.isShowSaveBtn = false;
      } else {
        this.isNotesAvailable = false;
      }
    });
  }

  addDetailNote() {
    $('.checkMakerNotes').slideDown();
    $('#notesTextArea').prop('readonly', false);
    this.service.addNote(this.guid).subscribe((data) => {
      this.currentResponseData = data;
      console.log(this.currentResponseData);
      this.isShowSaveBtn = true;
      this.isEdit = false;
      this.editResponseData = this.currentResponseData.data.Notes;
    });
  }

  closeNote() {
    $('#notesTextArea').val('');
    this.isShowSaveBtn = false;
    this.isEdit = false;
    $('#addNote').hide();
    $('.checkMakerNotes').slideUp();
  }

  saveNotes() {
    let dateTime = new Date();
    let notesEnrtyDate = dateTime.toISOString();
    let elementSubmit = <HTMLInputElement>document.getElementById('but_Submit');
    if (elementSubmit != null) {
      elementSubmit.disabled = false;
    }

    let index;
    if (this.currentResponseData != undefined && !this.isEdit) {
      this.currentResponseData.data.Notes.notesContent = this.notesField.nativeElement.value;
      this.currentResponseData.data.Notes.notesEnteredByUser = this.username;
      this.currentResponseData.data.Notes.notesEntryDt = notesEnrtyDate;
    } else {
      this.editResponseData.notesContent = this.notesField.nativeElement.value;
      this.editResponseData.notesEntryDt = notesEnrtyDate;
      this.editResponseData.notesEnteredByUser = this.username;
      this.editResponseData.id = this.noteId;
      this.editResponseData.versionID = this.notesVersion;
    }

    if (this.notesField.nativeElement.value.length > 1) {
      this.service
        .saveNote(
          this.currentResponseData != undefined && !this.isEdit
            ? this.currentResponseData.data.Notes
            : this.editResponseData
        )
        .subscribe((data) => {
          $('#notesTextArea').val('');
          $('.checkMakerNotes').slideUp();
          this.isNotesAvailable = true;

          setTimeout(() => {
            this.getNoteHistory(this.guid);
          }, 15);
        });
    }
  }

  public onInputFocused(item: FieldItem) {
    let functionName;
    functionName = item.fieldCd + '_focus';
    if (typeof this[functionName] === 'function') {
      eval('this.' + functionName + '(item)');
    }
  }

  notesContent_focus(item: FieldItem) {
    this.noteId = item.model.id;
    this.notesVersion = item.model.versionID;
    let elemProp = $('#' + item.model.guid + '_notesContent').attr('readonly');
    this.editNoteValue = item.model.notesContent;
    if (this.editResponseData === undefined) {
      this.editResponseData = item.model;
    }

    if (elemProp == 'readonly') {
      this.isEdit = true;
      this.isShowSaveBtn = false;
      $('#notesTextArea').attr('readonly', 'readonly');
      $('.checkMakerNotes').slideDown();
    } else {
      this.isEdit = true;
      this.isShowSaveBtn = true;
      $('#notesTextArea').prop('readonly', false);
      $('.checkMakerNotes').slideDown();
    }

    if (item.model.notesEnteredByUser == this.username && elemProp != 'readonly') {
      this.isEdit = true;
      this.isShowSaveBtn = true;
      $('.checkMakerNotes').slideDown();
      item.model['status'] = 'U';
      this.editResponseData['status'] = 'U';
    }
  }
}
